import { useLocation } from "react-router-dom";

const tabOptions = [
  { value: 0, label: "BUSINESS PLAN AI" },
  { value: 1, label: "COMIC VIDEO AI" },
  { value: 2, label: "SOCIAL MEDIA CONSULTANT" },
  { value: 3, label: "FACT OF THE DAY AI" },
  // { value: 3, label: "DEVELOPER AI" },
  { value: 4, label: "IMAGE AI" },
  { value: 5, label: "PROMO CAMPAIGN AI" },
  // { value: 5, label: "NEWS VIDEO AI" },
  { value: 6, label: "SOCIAL POST AI" },
  { value: 7, label: "POSTER DESIGN AI" },
  { value: 8, label: "PRODUCT VIDEO AI" },
  { value: 9, label: "VIDEO AI" },
  // { value: 8, label: "POST AI" },
  { value: 10, label: "TEXT AI" },
  // { value: 10, label: "TEXT VIDEO AI" },
  { value: 11, label: "TOY STORIES AI" },
  { value: 12, label: "VOICE AI" },
];

const HowItWorksDropdown = ({ tabValue, handleChangeTab }) => {
  const location = useLocation()
  const currentPathname = location.pathname;

  const filteredTabOptions = tabOptions.filter(option => {
    if (option.value === 2 && currentPathname === "/contents") {
      return false;
    }
    return true;
  });

  const handleSelectChange = (e) => {
    const newValue = parseInt(e.target.value, 10);
    handleChangeTab(e, newValue);
  };

  return (
    <div className="d-flex justify-content-center mb-3">
      <select
        className="form-select text-uppercase"
        value={tabValue}
        onChange={handleSelectChange}
        style={{ maxWidth: "350px" }}
      >
        {filteredTabOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default HowItWorksDropdown;
